import {Injectable} from '@angular/core';
import {ApiService} from "@core/shared/services/api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "@core/shared/models/pagination";
import {Transport} from "@core/shared/models/transport";
import {AdditionalHeader} from "@core/shared/models/http-client";
import {TransportCalculation} from "@core/shared/models/transport/transport-calculation";

@Injectable({
    providedIn: 'root'
})
export class TransportService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {}

    public getPaginationItemsAPI(params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<Pagination<Transport>> {

        let headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        additionalHeaders?.forEach(header => headers = headers.append(header.name, header.value.toString()));

        let url: string = `${this._apiService.getApiUrl(false, true)}/transports`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<Transport>>(url, {
            headers: headers
        });
    }

    public calculateItemAPI(id: number, data: object, additionalHeaders?: AdditionalHeader[]): Observable<TransportCalculation> {

        let headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        additionalHeaders?.forEach(header => headers = headers.append(header.name, header.value.toString()));

        const url: string = `${this._apiService.getApiUrl(false, true)}/transports/${id}/calculate`;

        return this._httpClient.post<TransportCalculation>(url, data, {
            headers: headers
        });
    }
}
